import { LocalStorage } from '@va/util/helpers';
import { StorageKeysManager } from '@va/util/misc';
import { isArray } from 'lodash';
import { useCallback, useState } from 'react';

export const useHiddenKPIs = ({ reportBlockId, namespace }: { reportBlockId: string; namespace: string }) => {
  const getKPIsLocalstorageKey = useCallback(
    () => StorageKeysManager.getHiddenKpisKey({ namespace, reportBlockId }),
    [namespace, reportBlockId],
  );

  const getStoredKPIs: () => string[] | undefined = useCallback(() => {
    const storedItems = LocalStorage.getItem(getKPIsLocalstorageKey());
    if (!storedItems || storedItems === 'null') return undefined;
    try {
      const kpis = JSON.parse(storedItems);
      if (isArray(kpis)) {
        return kpis;
      }
      return undefined;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }, [getKPIsLocalstorageKey]);

  const [hiddenKPIs, setHiddenKPIs] = useState(getStoredKPIs() ?? []);

  const toggleKpiVisibility = useCallback(
    (kpi: string) => {
      setHiddenKPIs((prev) => {
        const newItems = prev.includes(kpi) ? prev.filter((element) => element !== kpi) : [...prev, kpi];
        LocalStorage.setItem(getKPIsLocalstorageKey(), JSON.stringify(newItems));
        return newItems;
      });
    },
    [getKPIsLocalstorageKey],
  );

  return { hiddenKPIs, toggleKpiVisibility };
};
